import { useWizardChannelContext } from '../WizardChannelProvider';
import type { StepChannel } from '../types';

/**
 * Access the active StepChannel from inside step content.
 * Returns null when the component is not mounted inside a v2 wizard.
 */
export function useStepChannel(): StepChannel | null {
  const ctx = useWizardChannelContext();
  return ctx?.activeChannel ?? null;
}
